import { InjectionToken } from '@angular/core';
import { AvailableLanguage } from '@core/localization/available.language';
import { enGB, enUS, es, fr, Locale, ru } from 'date-fns/locale';


export type LocalizationConfig = {
    locales: {
        locale: Locale;
        iso: string;
    }[];
    defaultLocale: string;
    defaultDateLocal: Locale;
    defaultOutputDateFormat: string;
    defaultOutputDateTimeFormat: string;
    dateFormats: Record<string, { date: string; full: string; my: string }>;
};

export const defaultLocalizationConfig: LocalizationConfig = {
    locales: [
        {
            iso: AvailableLanguage.EnGb,
            locale: enGB,
        },
        {
            iso: AvailableLanguage.EnUs,
            locale: enUS,
        },
        {
            iso: AvailableLanguage.RuRu,
            locale: ru,
        },
        {
            iso: AvailableLanguage.EsEs,
            locale: es,
        },
        {
            iso: AvailableLanguage.FrFr,
            locale: fr,
        },
    ],
    defaultLocale: AvailableLanguage.EnGb,
    defaultDateLocal: enGB,
    defaultOutputDateFormat: 'yyyy-MM-dd',
    defaultOutputDateTimeFormat: 'yyyy-MM-dd hh:mm:ss',
    dateFormats: {
        [AvailableLanguage.EnUs]: { date: 'MM-dd-yyyy', full: 'MM-dd-yyyy HH:mm', my: 'MM/yyyy' },
        [AvailableLanguage.EnGb]: { date: 'dd/MM/yyyy', full: 'dd/MM/yy HH:mm', my: 'MM/yyyy' },
        [AvailableLanguage.FrFr]: { date: 'dd/MM/yyyy', full: 'dd/MM/yy HH:mm', my: 'MM/yyyy' },
        [AvailableLanguage.EsEs]: { date: 'dd/MM/yyyy', full: 'dd/MM/yy HH:mm', my: 'MM/yyyy' },
        [AvailableLanguage.RuRu]: { date: 'dd.MM.yyyy', full: 'dd.MM.yy HH:mm', my: 'MM/yyyy' },
    },
};

export const LOCALIZATION_CONFIG: InjectionToken<LocalizationConfig> = new InjectionToken<LocalizationConfig>('Localization config');
